import React from "react";
import "../assets/css/contact.css";

const ContactCard = ({ contactData }) => {
  const { title, header, desc, desc2, icon } = contactData;
  return (
    <>
      <div className="contact-card">
          <div className="contact-ten">
            <div className="contact-col">
              <p className="p-tag">{title}</p>
              <h3>{header}</h3>
              <p className="text-color">{desc}</p>
              <p className="text-color">{desc2 ?? ""}</p>
            </div>
            <div className="contact-col contact-icon">{icon}</div>
          </div>
      </div>
    </>
  );
};

export default ContactCard;
